module.exports = __webpack_public_path__ + "static/media/image7.ac8aa69b.jpg";